module.exports = __webpack_public_path__ + "media/images/emblems/Grosshoechstetten-coat_of_arms-20a9565e12d8fa12777cb0ae3c92a213.svg";